var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuizListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#000000",
    d: "M 127.5,78.5 C 234.501,78.3333 341.501,78.5 448.5,79C 464.061,80.5699 474.227,88.7366 479,103.5C 481.899,123.228 474.066,136.395 455.5,143C 343.5,143.667 231.5,143.667 119.5,143C 101.049,136.278 93.2157,123.112 96,103.5C 101.123,88.1934 111.623,79.8601 127.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#000000",
    d: "M -0.5,120.5 C -0.5,115.167 -0.5,109.833 -0.5,104.5C 5.96361,85.4232 19.2969,77.2566 39.5,80C 60.0807,87.6599 67.5807,102.16 62,123.5C 53.9362,139.948 40.7695,146.448 22.5,143C 10.9493,139.281 3.28261,131.781 -0.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#000000",
    d: "M 511.5,247.5 C 511.5,252.833 511.5,258.167 511.5,263.5C 507.35,275.149 499.35,282.982 487.5,287C 365.167,287.667 242.833,287.667 120.5,287C 104.296,282.465 95.9631,271.798 95.5,255C 96.6512,235.515 106.985,224.848 126.5,223C 244.5,222.333 362.5,222.333 480.5,223C 496.08,224.767 506.414,232.934 511.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#000000",
    d: "M -0.5,262.5 C -0.5,257.833 -0.5,253.167 -0.5,248.5C 5.96449,229.423 19.2978,221.256 39.5,224C 57.8724,230.228 66.0391,243.062 64,262.5C 54.1103,287.691 36.9436,294.191 12.5,282C 6.00513,276.817 1.67179,270.317 -0.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#000000",
    d: "M 126.5,366.5 C 196.834,366.333 267.167,366.5 337.5,367C 356.501,369.502 366.834,380.335 368.5,399.5C 366.927,415.903 358.26,426.403 342.5,431C 268.5,431.667 194.5,431.667 120.5,431C 101.306,424.795 93.1397,411.629 96,391.5C 100.936,376.726 111.103,368.393 126.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#000000",
    d: "M -0.5,406.5 C -0.5,401.833 -0.5,397.167 -0.5,392.5C 5.92745,373.438 19.2608,365.272 39.5,368C 57.8724,374.228 66.0391,387.062 64,406.5C 54.8689,430.809 38.3689,437.643 14.5,427C 7.15806,421.791 2.15806,414.957 -0.5,406.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizListIcon);
export default __webpack_public_path__ + "static/media/quizListIcon.4247c692.svg";
export { ForwardRef as ReactComponent };